import RestaurantManagement from './RestaurantManagement.vue';

export const restaurantManagementRoutes = [
  { path: '', component: RestaurantManagement, name: 'restaurant-management' }
];
